<template>
  <div class="input-range-layout">
    <input v-model="value0" @input="onChange" @focus="onFocus" @blur="onBlur" />
    <span class="input-range-separator">{{ separator }}</span>
    <input v-model="value1" @input="onChange" @focus="onFocus" @blur="onBlur" />
    <span class="input-range-suffix">{{ suffix }}</span>
    <i v-if="clearable" @click="onClear" class="el-icon-circle-close"></i>
  </div>
</template>

<script>
export default {
  name: "Input",
  props: {
    value: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    separator: {
      type: String,
      required: false,
      default: "--",
    },
    suffix: {
      type: String,
      required: false,
      default: "ms",
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      focus: false,
      value0: "",
      value1: "",
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal[0] === this.value0 && newVal[1] === this.value1) {
          return;
        } else {
          this.value0 = newVal[0];
          this.value1 = newVal[1];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onClear() {
      this.value0 = "";
      this.value1 = "";
      this.onChange();
    },
    onChange() {
      this.$emit("input", [this.value0, this.value1]);
      this.$emit("change", [this.value0, this.value1]);
    },
    onFocus() {
      this.focus = true;
    },
    onBlur() {
      this.focus = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.input-range-layout {
  display: inline-flex;
  border: 1px solid #d0d2d7;
  border-radius: 2px;
  box-sizing: border-box;
  color: #00102f;
  height: 32px;
  position: relative;
  input {
    padding: 0 8px;
    border: none;
    outline: none;
    width: 65px;
    text-align: center;
  }
  .input-range-suffix {
    padding: 0 8px;
    line-height: 30px;
  }
  .el-icon-circle-close {
    display: none;
    font-size: 14px;
    color: #c0c4cc;
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 5;
    background-color: #fff;
  }
  &:hover {
    .el-icon-circle-close {
      display: block;
    }
  }
}
</style>
